import { RoutesData } from '../../../routes/types';

export const initialState: RoutesData = {
  nextKey: -1,
  list: [],
};
